<script setup lang="ts" generic="ListingFilter extends { code: string }">
import type { Component } from "vue";
import ListingFiltersPriceVue from "./ListingFiltersPrice.vue";
import ListingFiltersPropertiesVue from "./ListingFiltersProperties.vue";
import ListingFiltersRatingVue from "./ListingFiltersRating.vue";
import ListingFiltersShippingFreeVue from "./ListingFiltersShippingFree.vue";

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters?: {
    [key: string]: unknown;
  };
  isFilterVisible?: boolean;
}>();

const emit = defineEmits<{
  selectFilterValue: [{ code: string; value: string | number | boolean }];
  toggle: [Event?];
}>();

const toggle = (event?: Event) => {
  emit('toggle', event);
};

const handleClickOutsideFilterItem = () => { 
  // Don't close on click outside in accordion mode, only via toggle
  // If you want to keep this functionality, you'll need to emit a close event
}

const cmsMap = () => {
  const map: {
    [key: string]: Component;
  } = {
    manufacturer: ListingFiltersPropertiesVue,
    properties: ListingFiltersPropertiesVue,
    price: ListingFiltersPriceVue,
    // rating: ListingFiltersRatingVue,
    "shipping-free": ListingFiltersShippingFreeVue,
  };

  return map[props.filter?.code];
};
</script>
<template>
  <div>
    <component
      :is="cmsMap()"
      :filter="filter"
      :selected-filters="selectedFilters"
      @select-value="emit('selectFilterValue', $event)"
      :isFilterVisible="isFilterVisible || false"
      :toggle="toggle"
      @update-visibility="handleClickOutsideFilterItem"
    />
  </div>
</template>
